module.exports = __webpack_public_path__ + "static/media/group-data-icon.d60d7519.svg";